import React, { useEffect, useState } from "react";
import { api } from "../../lib/api";
import { useI18n } from "../../lib/i18n";
import { Mail } from "lucide-react";

export function Waitlist() {
  const { t, lang } = useI18n();
  const [data, setData] = useState(null);
  useEffect(() => { api.get("/admin/waitlist").then((r) => setData(r.data)).catch(() => setData({ items: [], by_city: {}, total: 0 })); }, []);
  if (!data) return <div className="text-sm text-stone-500 p-8">{t("loading")}</div>;
  const fmt = (d) => new Date(d).toLocaleDateString(lang === "fr" ? "fr-FR" : "en-US", { day: "numeric", month: "short", year: "numeric" });
  return (
    <div className="mt-6" data-testid="waitlist">
      <h2 className="font-serif text-3xl">{t("waitlist_title")} <span className="text-stone-400 text-xl">({data.total})</span></h2>
      <div className="flex flex-wrap gap-2 mt-4">
        {Object.entries(data.by_city).sort((a, b) => b[1] - a[1]).map(([c, n]) => (
          <span key={c} data-testid={`waitlist-city-${c}`} className="text-xs px-3 py-1 rounded-full bg-stone-100 text-stone-700">{c} <span className="font-medium">{n}</span></span>
        ))}
      </div>
      {data.items.length === 0 ? (
        <div data-testid="waitlist-empty" className="mt-6 bg-white border border-dashed border-stone-300 rounded-3xl p-14 text-center text-stone-500 text-sm">{t("waitlist_none")}</div>
      ) : (
        <div className="mt-6 bg-white border border-stone-200 rounded-3xl overflow-hidden">
          <table className="w-full text-sm">
            <thead className="bg-stone-50 text-left text-xs uppercase tracking-wider text-stone-500">
              <tr><th className="px-5 py-3">{t("waitlist_email")}</th><th className="px-5 py-3">{t("waitlist_city")}</th><th className="px-5 py-3">{t("waitlist_date")}</th></tr>
            </thead>
            <tbody>
              {data.items.map((w) => (
                <tr key={w.id} data-testid={`waitlist-row-${w.id}`} className="border-t border-stone-100">
                  <td className="px-5 py-3 flex items-center gap-2"><Mail size={14} className="text-stone-400" />{w.email}</td>
                  <td className="px-5 py-3">{w.city}</td>
                  <td className="px-5 py-3 text-stone-500">{fmt(w.created_at)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
